import { registerPlugin } from 'app/src-capacitor/node_modules/@capacitor/core';
import { boot } from 'quasar/wrappers';
import { FCM } from 'app/src-capacitor/node_modules/@capacitor-community/fcm';
import { PushNotifications } from 'app/src-capacitor/node_modules/@capacitor/push-notifications';
import { Platform } from 'quasar';
import { App } from 'app/src-capacitor/node_modules/@capacitor/app';
import { Device } from 'app/src-capacitor/node_modules/@capacitor/device';

export interface RemoteConfig {
  initialize(payload: { minimumFetchIntervalInSeconds: number }): Promise<void>;
  fetchAndActivate(): Promise<void>;
  getString(payload: { key: string }): Promise<{ value: string }>;
}

let remoteConfig: RemoteConfig;

if (Platform.is.capacitor) {
  remoteConfig = registerPlugin<RemoteConfig>('RemoteConfigPlugin');

  remoteConfig
    .initialize({ minimumFetchIntervalInSeconds: 0 })
    .then(console.log)
    .catch(console.error);
}

const configInit = {
  realmId: process.env.REALM_PROJECT,
  dbName: process.env.DB_NAME,
  shareURL: process.env.VUE_APP_URL,
  build: '',
  version: '',
  device: ''
};

export default boot(async () => {
  if (Platform.is.capacitor) {
    await remoteConfig.fetchAndActivate();
    const realmIdObj = await remoteConfig.getString({ key: 'realm_id' });
    const dbNameObj = await remoteConfig.getString({ key: 'db_name' });
    const shareURLObj = await remoteConfig.getString({ key: 'share_url' });
    if (process.env.NODE_ENV === 'production') {
      configInit.shareURL = shareURLObj.value || configInit.shareURL;
      configInit.realmId = realmIdObj.value || configInit.realmId;
      configInit.dbName = dbNameObj.value || configInit.dbName;
    }

    const appInfo = await App.getInfo();
    configInit.build = appInfo.build;
    configInit.version = appInfo.version;

    const deviceInfo = await Device.getInfo();
    configInit.device = `${deviceInfo.platform} (${deviceInfo.osVersion}) / ${
      deviceInfo.webViewVersion
    }`;

    await PushNotifications.requestPermissions().catch(console.error);
    await PushNotifications.register().catch(console.error);
    FCM.getToken()
      .then(r => console.log(`Token ${r.token}`))
      .catch(err => console.log(err));
  }
});

export const config = () => {
  return configInit;
};
